import Vue from 'vue'
import axios from 'axios'

export default {
    state: {
        retrievedData: false,
        publicChatrooms: []
    },

    actions: {
        'publicChatsModel/fetchPublicChats': function (context, data, callback) {
            axios.get('/api/publicChatRooms').then(
                (response) => {
                    context.commit('publicChatsModel/setPublicChatrooms', response.data);

                    if (callback && typeof callback === 'function') {
                        callback();
                    }
                }
            )
        }
    },

    mutations: {
        'publicChatsModel/setPublicChatrooms': function (state, data) {
            state.retrievedData = true;
            state.publicChatrooms = data;
        },

        'publicChatsModel/clearReadMessages'(state, data){
            state.publicChatrooms.forEach(function (chatroom) {
                if (chatroom.id === data.chatId) {
                    Vue.set(chatroom, 'unreadMessages', 0);
                }
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/ChatRoom/PublicChatsModel.js